import React from 'react';
import PropTypes from 'prop-types';

import { SplashContainer, SplashTitle } from './styled';

const SplashLoading = ({ getTexts, moduleName }) => (
  <SplashContainer>
    <i className="fas fa-spinner fa-2x fa-spin" />
    <SplashTitle>{`${getTexts('Loading')}${moduleName ? getTexts(moduleName) : ''}...`}</SplashTitle>
  </SplashContainer>
);

SplashLoading.defaultProps = {
  getTexts: (val) => val,
  moduleName: '',
};

SplashLoading.propTypes = {
  getTexts: PropTypes.func,
  moduleName: PropTypes.string,
};

export default SplashLoading;
